<app-loading-spinner *ngIf="loading; else not_loading"></app-loading-spinner>
<ng-template #not_loading>
  <table class="table" *ngIf="classes && classes.length; else no_classes">
    <thead>
      <th>Class Name</th>
      <th><span>Teacher</span></th>
      <th><span>Class Code</span></th>
      <th><span ngbTooltip="Student count"><i class="fas fa-user"></i></span></th>
      <th><span ngbTooltip="Latest section start date">Start</span></th>
      <th><span ngbTooltip="Latest section end date">End</span></th>
      <!-- <th></th> -->
    </thead>
    <tbody>
      <tr *ngFor="let class of classes" class="hover" (click)="navigateToClass(class)">
        <td>
          <a [routerLink]="getRouterLink(class)">
            {{ class.Description }}
          </a>
        </td>
        <td>
          {{getTeacherName(class)}}
        </td>
        <td>
          {{class.LoginCode}}
        </td>
        <td>
          {{ class.StudentCount }}
        </td>
        <td>
          {{ class.StartingOn | date }}
        </td>
        <td>
          {{ class.Ending | date }}
        </td>
      </tr>
    </tbody>
  </table>
  <div *ngIf="showMultipleTeacherHint()" style="color:gray; font-style:italic">* indicates more than one teacher</div>
  <ng-template #no_classes>
    <p class="mt-4">
      <ng-container *ngIf="classes && !classes.length">
        No classes found.
      </ng-container>
      <app-loading-spinner *ngIf="!classes"></app-loading-spinner>
    </p>
  </ng-template>
</ng-template>
